import { LiveScoreStreamingFetchCount } from '../components/LiveScore/liveScoreConstants';

const isValidPartialJSON = (data) => {
    try {
        JSON.parse(data);
        return true;
    } catch {
        return false;
    }
};

const formatDataWithClosingPattern = (data, isLiveScoreToday) => {
    const TRUNCATION_PATTERN = '"}},';

    const lastIndex = data.lastIndexOf(TRUNCATION_PATTERN);

    if (lastIndex === -1) {
        return data;
    }

    const closePattern = isLiveScoreToday ? ']}' : ']}}';

    return `${data.slice(0, lastIndex + TRUNCATION_PATTERN.length - 1)}${closePattern}`;
};

const appendToPartialData = (partialData, value) => {
    return partialData + new TextDecoder().decode(value);
};

const streamingFetcher = async ({ url, options, isLiveScoreToday }) => {
    const response = await fetch(url, options);

    if (!response.ok) {
        throw new Error('An error occurred while fetching the data.');
    }

    const reader = response.body.getReader();

    let partialData = '';

    while (true) {
        const { done, value } = await reader.read();

        if (done) {
            break;
        }

        partialData = appendToPartialData(partialData, value);

        const formattedPartialData = formatDataWithClosingPattern(partialData, isLiveScoreToday);

        if (isValidPartialJSON(formattedPartialData)) {
            try {
                const currentData = JSON.parse(formattedPartialData);

                if (isLiveScoreToday) {
                    if (currentData.match && currentData.match.length >= LiveScoreStreamingFetchCount) {
                        return currentData;
                    }
                }

                if (currentData?.Result?.Match && currentData?.Result?.Match.length >= LiveScoreStreamingFetchCount) {
                    return currentData;
                }
            } catch (error) {
                // If parsing fails, wait for more data.
                console.error('Error parsing partial JSON:', error.message);
            }
        }
    }

    try {
        return JSON.parse(partialData);
    } catch (error) {
        throw new Error('Failed to parse the received data as JSON.');
    }
};

export default streamingFetcher;
